export const environment = {
  production: false,
  apiUrl: 'https://qa.backend.dibson.dance/',
  hostUrl: 'https://qa.pro.dibsondance.com',
  joinProUrl: 'https://qa.bilety.dibsondance.com',
  portalUrl: 'https://qa.dibsondance.com',
  googleMapsApiKey: 'AIzaSyCjLyKcEW9occRY9dX2mzd0_UCGhhJWwpM',
  geocodingApiKey: 'AIzaSyDGZZEpK3g-1BDRMU2YBYXBgAqniL3n2NE',
  buildTimestamp: '2026-11-03T18:25:48.000Z',
  // DOD-638 — scanner store links, mirrored from the backend's
  // GET /hosts/self/offerings/{id}/check-in/config. Change both places
  // together, and re-download public/images/scanner-qr-*.png with them.
  scanner: {
    iosUrl: 'https://apps.apple.com/app/check-in-dibs-on-dance/id6754178663',
    androidUrl: 'https://play.google.com/store/apps/details?id=com.dibsondance.prod',
  },
};
